import React from "react";
import Navbar from "./Navbar";
import Slider from "./slider/Slider";
import Footer from "../Footer/Footer";
import Lobby from '../../assets/area-11-lobby.jpg'
import room from '../../assets/guzape-mini-suite.jpg'
import './NavAbout.css'

const NavAbout = () => {
  return (
    <div>
      <Navbar />
      <section className="hero" style={{ marginTop: "10%" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="copy">
                <div className="text-label">About Residency Hotels Limited</div>
                <div className="text-hero-bold">
                  For Your Luxury and Comfort stay
                </div>
                <div className="text-hero-regular">
                  Residency Hotels & Resorts is a distinguished name in the
                  hospitality industry, driven by our commitment to creating
                  cherished memories for our guests. With a heritage spanning
                  over a century, we have honed our craft as hoteliers and
                  instilled a deep-rooted tradition of exceptional hospitality.
                  <p>
                    At Residency Hotels, we believe that every guest deserves a
                    warm welcome and an extraordinary experience. From the
                    moment you step through our doors, you will be greeted with
                    genuine warmth and a dedication to making you feel special,
                    valued, and appreciated. Our team is committed to going
                    above and beyond to ensure your stay is nothing short of
                    exceptional.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 images  ">
              <Slider />
            </div>
          </div>
          <br/>
          {/* second paragraph */}
          <p></p>
          <div className="row">
            <div className="col-md-6 sideImg">
              {/* <Slider /> */}
              <img src={Lobby} alt='side image' />
            </div>
            <div className="col-md-6 images  ">
              <div className="copy">
              <div className="text-hero-bold">
                  Our Mission
                </div>
                <div className="text-hero-regular">
                    Our accommodations are meticulously designed to provide a
                    perfect blend of comfort, security, and affordability. We
                    understand that a truly memorable stay encompasses more than
                    just a well-appointed room. It's about creating an ambiance
                    that reflects our guests' diverse needs and desires. That's
                    why we have carefully curated localized entertainment
                    options, ensuring that you have a taste of the local culture
                    and experiences.
                  <p>
                    With our rapid growth, Residency Hotels now boasts nine
                    locations across Nigeria. We have four exquisite hotels in
                    Abuja, two in Lagos, one in Enugu, one in Ogidi (Anambra
                    State), and one in Owerri (Imo State). Each of our
                    properties showcases the unique essence of its location,
                    allowing you to explore the rich tapestry of Nigeria's
                    vibrant culture and heritage.
                  </p>
                </div>
              </div>
            </div>
          </div>
            <br/>
          {/* third paragraph */}
          <p></p>

          <div className="row">
            <div className="col-md-6">
              <div className="copy">
              <div className="text-hero-bold">
                  Our Vision
                </div>
                <div className="text-hero-regular">
            
                    Our vision extends beyond providing exceptional hospitality
                    within Nigeria. We aspire to establish a hotel chain that is
                    entirely managed by Nigerians, yet stands on par with
                    international standards of excellence. Our team of dedicated
                    hoteliers brings a wealth of experience from both domestic
                    and international settings, ensuring that every aspect of
                    your stay is meticulously crafted to meet the highest
                    standards.
                
                  <p>
                    Whether you are traveling for business, leisure, or a
                    special occasion, Residency Hotels is committed to
                    delivering an exceptional experience that surpasses your
                    expectations. We invite you to embark on a journey with us,
                    where impeccable service, attention to detail, and a
                    commitment to excellence are the hallmarks of our
                    hospitality.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 sideImg  ">
              {/* <Slider /> */}
              <img src={room} alt='side image' />
            </div>
          </div>

          {/* last paragraph */}
          <p></p>

          <div className="row">
            <div className="col-md-10">
              <div className="copy">
                <div className="text-hero-regular">
             
                  <p>
                     Join us at Residency Hotels & Resorts
                    and allow us to create unforgettable moments that will stay
                    with you long after your departure. We are honored to be a
                    part of your journey and look forward to welcoming you to
                    our family.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default NavAbout;
